/* eslint-disable camelcase */
import { MESSAGE_TYPES } from 'ai/constants/superchat';

function mapPreviousConversations(conversations) {
    const { messages } = conversations;

    return messages
        .sort((a, b) => a.created_at - b.created_at)
        .map(conv => {
            if (conv.role === 'user') {
                return {
                    response_type: MESSAGE_TYPES.USER_QUERY,
                    data: {
                        query: conv.content
                    }
                };
            }

            return {
                response_type: MESSAGE_TYPES.USER_QUERY_RESPONSE,
                data: {
                    stream: false,
                    summary: conv.content
                }
            };
        });
}

export default mapPreviousConversations;
